/* eslint-disable @typescript-eslint/no-explicit-any -- DIRECT-239681 */
import { isObject } from './isObject';
import { keys } from './keys';
/**
 * Сериализация объекта в строку с сортировкой ключей, чтобы
 * гарантировать одинаковый результат для одинаковых объектов.
 *
 * @param obj Объект, который нужно сериализовать
 * @typeParam T Тип объекта
 * @returns Строка, представляющая собой сериализованный объект
 *
 * @example
 * ```typescript
 * import { stableSerialize } from '@direct-frontend/stdlib';
 *
 * stableSerialize({ a: 1, b: { c: 2 }, d: [1, 2, 3] });
 * // '{"a":1,"b":{"c":2},"d":[1,2,3]}'
 * ```
 */
export function stableSerialize(obj) {
    return JSON.stringify(obj, (_, value) => {
        if (isObject(value)) {
            return keys(value)
                .sort()
                .reduce((acc, key) => {
                acc[key] = value[key];
                return acc;
            }, {});
        }
        if (typeof value === 'symbol') {
            return value.toString();
        }
        return value;
    });
}
